/* unplugin-vue-components disabled */import script from "./WxNativePay.vue?vue&type=script&setup=true&lang=ts"
export * from "./WxNativePay.vue?vue&type=script&setup=true&lang=ts"

import "./WxNativePay.vue?vue&type=style&index=0&id=197164ff&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197164ff"]])

export default __exports__